// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AaIP","colBig":"styles_colBig__2Idnj","colSmall":"styles_colSmall__3ewNy"};